import {
  Component,
  OnInit,
  Renderer2,
  HostBinding
} from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, FormGroup, FormBuilder } from '@angular/forms';
import { ILoginScreen, SharedService } from '@services/shared.service';
import { ToastrService } from 'ngx-toastr';
declare var QRCode: any;
declare var QRCodeKey: any;

const phoneEmailRegex = /^(\d{10}|\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3}))$/;
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  @HostBinding('class') class = 'login-box';
  public loginForm: UntypedFormGroup;
  public MFAForm: UntypedFormGroup;
  
  public isAuthLoading = false;
  public QRCode = '';
  public QRCodeKey: '';
  public showPassword: boolean = false;
  public currentScreen: ILoginScreen;
  public version: string = "";
  message : any;
  rememberMeDays : number = 0;
  year : number;
  
  public login_form: FormGroup;
  constructor(private renderer: Renderer2,private toastr: ToastrService, private sharedService: SharedService,fb: FormBuilder) {
    this.QRCode = QRCode;
    this.QRCodeKey = QRCodeKey;
    this.message = window["message"];
    this.rememberMeDays = window["rememberMeDays"];
    this.version = window["version"];
    this.year = new Date().getFullYear();
    this.login_form = fb.group({
      Username: [null, Validators.required],
      Password: [null, Validators.required],
    });

    this.MFAForm = fb.group({
      MFACode: [null, [Validators.required, Validators.pattern(/^[0-9]+$/)]]
    });
  }

  ngOnInit() {
    this.renderer.addClass(
      document.querySelector('app-root'),
      'login-page'
    );
    this.loginForm = new UntypedFormGroup({
      email: new UntypedFormControl(null, Validators.required),
      password: new UntypedFormControl(null, Validators.required)
    });
    this.sharedService.currentScreen.subscribe(screen => {
      this.currentScreen = screen;
    });
  }

  public togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  async loginByAuth() {
    if (this.loginForm.valid) {
      this.isAuthLoading = true;
      this.isAuthLoading = false;
    } else {
      this.toastr.error('Form is not valid!');
    }
  }
  ngOnDestroy() {
    this.renderer.removeClass(
      document.querySelector('app-root'),
      'login-page'
    );
  }
}
